import * as React from 'react';
import PropTypes from 'prop-types';
import {Box,Card} from '@mui/material';

export function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Card
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      sx={{
        position:"static",
        overflowX: "hidden",
        width:'100%',
        
        bgcolor:'inherit'
      }}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      

      
    >
      {value === index && (
        <Box 
        sx={{ 
          p: 1,
          // height:"fit-content",
           }}>
         {children}
        </Box>
      )}
    </Card>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

